import React from 'react';
import { Box } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  BodyText,
  HeaderText,
  Stack,
  Tag,
  Absolute,
} from '../../../ui';
import { ProAppointmentDetails } from '../../../../api/Providers/Appointments';

type CancelledAppointmentDetailsProps = {
  appointment: ProAppointmentDetails;
};

const CancelledAppointmentDetails:
React.FC<CancelledAppointmentDetailsProps> = ({
  appointment,
}) => {
  const appointmentDate = new Date(appointment.local_start);
  const dateString = appointmentDate.toLocaleDateString(
    'en-US',
    {
      weekday: 'long',
      year: undefined,
      month: 'long',
      day: 'numeric',
    },
  );

  const timeString = appointmentDate.toLocaleTimeString(
    'en-US',
    {
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
    },
  );

  return (
    <Box
      padding={4}
    >
      <Box
        borderRadius={6}
        showBoxShadow
        padding={16}
        color={colors.whiteWash}
      >
        <Stack>
          <HeaderText
            level={4}
            testID="appointment_cancel_search_rank_impact_cancelled_appointment_details_client_name"
          >
            {appointment.client?.name.split(' ')[0]}
          </HeaderText>
          <BodyText
            appearance="medium"
            color={colors.metal}
            testID="appointment_cancel_search_rank_impact_cancelled_appointment_details_service_name"
          >{
              (appointment.time_blocks?.[0].service_name)
            }
          </BodyText>
          <BodyText
            appearance="medium"
            color={colors.metal}
            testID="appointment_cancel_search_rank_impact_cancelled_appointment_details_date"
          >
            {dateString} at {timeString}
          </BodyText>
        </Stack>
        <Absolute
          top={16}
          right={16}
        >
          <Box right={0}>
            <Tag
              paddingX={8}
              paddingY={4}
              borderRadius={16}
              fontWeight="200"
              textTransform="none"
              color={colors.red}
              textColor={colors.whiteWash}
            >
              Canceled
            </Tag>
          </Box>
        </Absolute>
      </Box>
    </Box>
  );
};

export default CancelledAppointmentDetails;
